import { useGetDownloadSignedUrlForTaskQuestionLazyQuery } from '@exam-management/graphql';
import { extractImagesFileNames, updateImageTags } from '@exam-management/rich-text-editor';
import { useCallback } from 'react';

export interface UseParseContentForSingleQuestionInput {
  questionId: string;
  taskId: string;
}

export interface UseParseContentForItemSetQuestionInput {
  questionGroupId: string;
  taskId: string;
}

type UseParseContentForQuestionCreationInput =
  | UseParseContentForSingleQuestionInput
  | UseParseContentForItemSetQuestionInput;

export function useParseContentForQuestionCreation(
  params: UseParseContentForQuestionCreationInput,
) {
  const questionGroupId = 'questionGroupId' in params ? params.questionGroupId : undefined;
  const questionId = 'questionId' in params ? params.questionId : undefined;
  const taskId = params.taskId;

  const [getDownloadSignedUrlForQuestion] = useGetDownloadSignedUrlForTaskQuestionLazyQuery();

  const parseContentForDisplay = useCallback(
    async (content: string) => {
      const fileNames = extractImagesFileNames(content);

      if (fileNames.length === 0) {
        return content;
      }

      const { data } = await getDownloadSignedUrlForQuestion({
        variables: {
          input: { fileNames, questionId, questionGroupId },
          taskId,
        },
      });

      const urlObject: Record<string, string> | undefined =
        data?.qctGetDownloadSignedUrlForTaskQuestion?.signedUrls;

      if (!urlObject) {
        return content;
      }

      return updateImageTags(content, urlObject);
    },
    [questionId, questionGroupId, getDownloadSignedUrlForQuestion, taskId],
  );

  return { parseContentForDisplay };
}
